import { TabsProps } from 'antd';
import { AgendaCommercialeTabs } from 'enums/project.enum';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useAgendaCommercialeTabs = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<string>(AgendaCommercialeTabs.ACTIONS);

  const agendaCommercialeTabs: TabsProps['items'] = [
    { key: AgendaCommercialeTabs.ACTIONS, label: t('Azioni') },
    { key: AgendaCommercialeTabs.OPPORTUNITIES, label: t('Opportunity') },
    { key: AgendaCommercialeTabs.TAB_2, label: t('Dashboard') },
  ];

  const onChangeTab = (key: string) => {
    setSelectedTab(key);
  };

  return { selectedTab, agendaCommercialeTabs, onChangeTab };
};

export default useAgendaCommercialeTabs;
